import { render, staticRenderFns } from "./JournalTicketsNavbar.vue?vue&type=template&id=bea6e278&scoped=true"
import script from "./JournalTicketsNavbar.vue?vue&type=script&lang=js"
export * from "./JournalTicketsNavbar.vue?vue&type=script&lang=js"
import style0 from "./JournalTicketsNavbar.vue?vue&type=style&index=0&id=bea6e278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea6e278",
  null
  
)

export default component.exports